export const AGENT_FILE_SETTINGS_VALUES = [
  'none',
  'optional',
  'required',
] as const;

export type AgentFileSettings = (typeof AGENT_FILE_SETTINGS_VALUES)[number];

export const AGENT_FILE_SETTINGS_LABELS: Record<AgentFileSettings, string> = {
  none: 'N/A',
  optional: 'Optional',
  required: 'Required',
};
